var _path, _line, _line2, _line3, _line4, _rect, _rect2, _rect3, _rect4, _path2, _path3, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V40H10C4.47715 40 0 35.5228 0 30V10Z",
    fill: "#C4DEF5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 10.5,
    x2: 7.5,
    y2: 29.5,
    stroke: "#144066",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32.5,
    y1: 10.5,
    x2: 32.5,
    y2: 29.5,
    stroke: "#144066",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 7.5,
    x2: 30.5,
    y2: 7.5,
    stroke: "#144066",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 32.5,
    x2: 29.5,
    y2: 32.5,
    stroke: "#144066",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#144066"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 5,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#144066"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#144066"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 29,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#144066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 28.5714C20 28.5714 26 22.5966 26 17.6623C26 14.2195 23.3137 11.4286 20 11.4286C16.6863 11.4286 14 14.2195 14 17.6623C14 22.5267 20 28.5714 20 28.5714ZM20 20.8571C21.8935 20.8571 23.4286 19.3221 23.4286 17.4286C23.4286 15.535 21.8935 14 20 14C18.1065 14 16.5714 15.535 16.5714 17.4286C16.5714 19.3221 18.1065 20.8571 20 20.8571Z",
    fill: "#144066"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19Q20 17 22 19",
    stroke: "#144066",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 16,
    r: 0.7,
    fill: "#144066"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 16,
    r: 0.7,
    fill: "#144066"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSad);
export default __webpack_public_path__ + "static/media/logo-sad.d22c0e2a643d82aaae817cf5f3d3835e.svg";
export { ForwardRef as ReactComponent };